export enum PickersRoutesEnum{
    PICKERS_LIST = 'pickers-list'
}